// extracted by mini-css-extract-plugin
module.exports = {"videosWrapper":"videos_section_videosWrapper__1U6i2","videosBanner":"videos_section_videosBanner__hEraM"};